import SvgIcon from "@mui/material/SvgIcon";
import PropTypes from "prop-types";
import React from "react";

// Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.
export default class TwitchIcon extends React.Component {
  static propTypes = {
    style: PropTypes.object,
  };

  render() {
    return (
      <SvgIcon viewBox="0 0 512 512" style={this.props.style}>
        <path d="M391.2 103.5H352.5v109.7h38.6zM285 103H246.4V212.8H285zM120.8 0 24.3 91.4V420.6H140.1V512l96.5-91.4h77.3L487.7 256V0zM449.1 237.8l-77.2 73.1H294.6l-67.6 64v-64H140.1V36.6H449.1z" />
      </SvgIcon>
    );
  }
}
